if (!customElements.get('ots-critical-disclosures')) {
  class OtsCriticalDisclosures extends HTMLElement {
    connectedCallback() {
      if (this.isConnectedToDisclosureLinks) return;

      this.isConnectedToDisclosureLinks = true;
      this.handleClick = this.handleClick.bind(this);
      this.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      this.isConnectedToDisclosureLinks = false;
    }

    handleClick(event) {
      const link = event.target.closest('[data-ots-critical-disclosure-link]');
      if (!link || !this.contains(link)) return;

      const targetId = decodeURIComponent(link.hash.slice(1));
      const target = targetId ? document.getElementById(targetId) : null;
      if (!target) return;

      event.preventDefault();

      const disclosureDetails = target.closest('.disclosures__details');
      if (disclosureDetails) disclosureDetails.open = true;

      document.querySelectorAll('.disclosures-item.is-targeted').forEach((item) => {
        if (item !== target) item.classList.remove('is-targeted');
      });
      target.classList.add('is-targeted');

      if (window.location.hash !== link.hash) {
        window.history.pushState(null, '', link.hash);
      }

      const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';

      window.requestAnimationFrame(() => {
        target.scrollIntoView({ behavior, block: 'start' });
        window.requestAnimationFrame(() => target.focus({ preventScroll: true }));
      });
    }
  }

  customElements.define('ots-critical-disclosures', OtsCriticalDisclosures);
}
